import React from "react";
import { ControlPanelContainer } from "./styles";
import Loading from "../../../common/Loading";

function ControlPanel(props) {
  return <ControlPanelContainer>
    <Loading loadingItem="Featured to be added soon"/>
  </ControlPanelContainer>;
}
export default ControlPanel;